{
    "longSHA": "2f038a9e6071d50f3fe96872497904b04f75e2e2",
    "shortSHA": "2f038a9",
    "branch": "development",
    "authorName": "Damjan Tonkli",
    "commitTime": "Wed Jan 14 09:31:35 2026 +0100",
    "commitMsg": "feat(ticketing): contract ticket exchange rate conversion date\n\nRefs: #41851",
    "totalCommitCount": "1"
}